import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SpaceIntroComponent } from './sections/space/space-intro/space-intro.component';
import { SpaceCarouselComponent } from './sections/space/space-carousel/space-carousel.component';
import { SkyIntroComponent } from './sections/sky/sky-intro/sky-intro.component';
import { SkyCarouselComponent } from './sections/sky/sky-carousel/sky-carousel.component';
import { SeaIntroComponent } from './sections/sea/sea-intro/sea-intro.component';
import { SeaCarouselComponent } from './sections/sea/sea-carousel/sea-carousel.component';
import { CityIntroComponent } from './sections/city/city-intro/city-intro.component';
import { CityCarouselComponent } from './sections/city/city-carousel/city-carousel.component';

export const appRoutes: Routes = [
	/*{
		path: '',
		redirectTo: 'Space',
		pathMatch: 'full' 
	},*/
	{
		path: '',
		component: HomeComponent,
		data: { position: 'home' },
	},
	/*{
		path: 'Space',
		component: SpaceIntroComponent,
		data: { position: 'intro-1' },
	},*/
	{
		path: 'Exploration/story',
		component: SpaceCarouselComponent,
		data: { position: 'story-1' }
	},
	/*{
		path: 'Sky',
		component: SkyIntroComponent,
		data: { position: 'intro-2' }
	},*/
	{
		path: 'Innovation/story',
		component: SkyCarouselComponent,
		data: { position: 'story-2' }
	},
	/*{
		path: 'City',
		component: CityIntroComponent,
		data: { position: 'intro-3' }
	},*/
	{
		path: 'NewYorkCity/story',
		component: CityCarouselComponent,
		data: { position: 'story-3' }
	},
	/*{
		path: 'Sea',
		component: SeaIntroComponent,
		data: { position: 'intro-4' }
	},*/
	{
		path: 'PopCulture/story',
		component: SeaCarouselComponent,
		data: { position: 'story-4' }
	}
];